import React, { useState } from 'react'
import styled from 'styled-components'

const Style = styled.div`
  background-color: rgb(22, 41, 65);
  border-radius: 16px;
  overflow: hidden;
  position: relative;

  iframe,
  img {
    aspect-ratio: var(--aspect-ratio-video);
    display: block;
    width: 100%;
  }

  iframe {
    border: none;
  }

  img {
    object-fit: cover;
  }

  .overlay {
    align-items: center;
    background-color: rgba(22, 41, 65, 0.65);
    border: none;
    cursor: pointer;
    display: flex;
    height: 100%;
    justify-content: center;
    left: 0;
    padding: 16px;
    position: absolute;
    top: 0;
    transition: background-color 400ms cubic-bezier(0.4, 0, 0.2, 1);
    width: 100%;

    &:hover {
      background-color: rgba(22, 41, 65, 0.75);

      .content {
        scale: 1.05;
      }
    }
  }

  .content {
    align-items: center;
    color: #ffffff;
    display: flex;
    font-size: 18px;
    font-weight: bold;
    gap: 4px;
    margin-left: -24px;
    margin-bottom: -4px;
    transition: scale 400ms cubic-bezier(0.4, 0, 0.2, 1);
  }
`

function EmbedVideo(Component) {
  const Video = (props) => {
    return (
      <Style>
        <Component />
      </Style>
    )
  }

  return Video
}

function EmbedVideoYoutube({ id }) {
  const [isVisible, setIsVisible] = useState(false)

  return (
    <Style>
      {isVisible ? (
        <iframe
          src={`https://www.youtube.com/embed/${id}?autoplay=1&rel=0`}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        />
      ) : (
        <>
          <img src={`https://img.youtube.com/vi/${id}/hqdefault.jpg`} />
          <div
            className="overlay"
            type="button"
            onClick={() => setIsVisible(true)}
          >
            <div className="content">
              <svg
                fill="none"
                viewBox="0 0 16 16"
                xmlns="http://www.w3.org/2000/svg"
                style={{
                  display: 'block',
                  width: '32px'
                }}
              >
                <path
                  d="m12.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.803.803 0 0 1 0 1.393Z"
                  fill="currentColor"
                />
              </svg>
              Watch Video
            </div>
          </div>
        </>
      )}
    </Style>
  )
}

export default EmbedVideoYoutube
